import axios from "axios";
import {
  BASE_URL,
  SECRET_KEY_ENCRYPT,
  ACCOUNT_CAISSE_POLEPARA,
  ACCOUNT_CAISSE_SAID,
  ADMIN_PASSWORD,
} from "./utils/config";
import Cryptr from "cryptr";
import ls from "local-storage";
import md5 from "react-native-md5";

const Connexion = {
  isAuthenticated: false,
  async authenticate(params) {
    let url = BASE_URL + "auth";

    let finalToken = await axios
      .post(url, params)
      .then((response) => {
        // 2FA enabled on this account: no session yet, Login.js asks for the code.
        if (response.data.mfa_required) {
          return {
            mfaRequired: true,
            mfaSetup: response.data.mfa_setup,
            mfaToken: response.data.mfa_token,
            otpauthUrl: response.data.otpauth_url,
            otpSecret: response.data.otp_secret,
          };
        }
        return this.storeSession(response.data, params);
      })
      .then((token) => {
        return token;
      })
      .catch((error) => {
        
        console.log("Error during authentication:", error);

        if (error.response) {
          // Server responded with a status code outside the 2xx range
          if (error.response.status === 500) {
            // Check if the error message indicates incorrect credentials
            if (error.response.data.status === "login ou mot de passe incorrect !!!") {
              // Shown on the login page itself (no blocking browser alert).
            } else {
              // Other server-side issues, like CORS
              window.location.href = "/underMaintenance";
            }
          } else {
            // Handle other response status codes
            window.location.href = "/underMaintenance";
          }
        } else if (error.request) {
          // The request was made but no response was received
          console.error("No response received, possible CORS issue.");
          window.location.href = "/underMaintenance";
        } else {
          // Other errors
          console.error("Error setting up request:", error.message);
          window.location.href = "/underMaintenance";
        }
    
        this.isAuthenticated = false;
        return null;
      });

    return finalToken;
  },
  // Second login step: 6-digit code from the authenticator app.
  // Returns the token, or { error: "code" | "expired" | "tooMany" }.
  async verifyOtp(mfaToken, code, params) {
    try {
      const response = await axios.post(BASE_URL + "auth/2fa/verify", {
        mfa_token: mfaToken,
        code: code,
      });
      return this.storeSession(response.data, params);
    } catch (error) {
      if (error.response && error.response.status === 401) {
        return { error: error.response.data.mfa_expired ? "expired" : "code" };
      }
      if (error.response && error.response.status === 429) {
        return { error: "tooMany" };
      }
      window.location.href = "/underMaintenance";
      return null;
    }
  },
  storeSession(data, params) {
    let cryptr = new Cryptr(SECRET_KEY_ENCRYPT);

    let token = data.token;
    let flagcataloge = data.flagcataloge;
    let afficher_catalogue = data.afficher_catalogue;
    let afficher_tableau_de_bord = data.afficher_tableau_de_bord;
    let afficher_client = data.afficher_client;
    let afficher_gestion_de_stock = data.afficher_gestion_de_stock;
    let afficher_bon_commande = data.afficher_bon_commande;
    let afficher_inventaire = data.afficher_inventaire;
    let afficher_lalivraison = data.afficher_lalivraison;
    let afficher_facturation = data.afficher_facturation;
    let afficher_facture_fournisseur =
      data.afficher_facture_fournisseur;
    let afficher_devis = data.afficher_devis;
    let id_account_caisse = data.id_account_caisse;
    let afficher_deliverect = data.afficher_deliverect;
    let afficher_cheques = data.afficher_cheques;
    let afficher_privileges = data.afficher_privileges;
    let groupeclients = data.groupeclients;
    let reglesdereduction = data.reglesdereduction;
    let reglesdeprix = data.reglesdeprix;
    let channel_manager = data.channel_manager;
    let client_commun = data.client_commun
    let isAdmin = data.is_admin;
    let view_own_documents = data.view_own_documents;
    let devis_create = data.devis_create;
    let devis_update = data.devis_update;
    let devis_convert_to_proforma = data.devis_convert_to_proforma;
    let proforma_update = data.proforma_update;
    let proforma_generate_bon_sortie = data.proforma_generate_bon_sortie;
    let proforma_generate_bon_livraison = data.proforma_generate_bon_livraison;
    let proforma_convert_to_facture = data.proforma_convert_to_facture;
    let facture_view = data.facture_view;
    let account_name_scA = data.account_name;
    let site_exist = data.pop_lacaissePay;
    let sc_uuid = data.uuid;
    let show_store = data.show_store;
    let from_admin_temp_password = data.from_admin_temp_password;
    let temp_tableau_de_bord = data.temp_tableau_de_bord;
    let afficher_mon_compte = data.afficher_mon_compte;
    if (token !== "") {
      ls.set("connected", true);
      this.isAuthenticated = true;
    } else {
      // error connexion
      ls.set("connected", false);
      this.isAuthenticated = false;
    }

    // Store the token
    ls.set("redirect", "");
    ls.set("email", params.login);
    ls.set("password", params.password);
    ls.set("flagcataloge", flagcataloge);
    ls.set("afficher_catalogue", afficher_catalogue);
    ls.set("afficher_tableau_de_bord", afficher_tableau_de_bord);
    ls.set("afficher_client", afficher_client);
    ls.set("afficher_gestion_de_stock", afficher_gestion_de_stock);
    ls.set("afficher_bon_commande", afficher_bon_commande);
    ls.set("afficher_inventaire", afficher_inventaire);
    ls.set("afficher_lalivraison", afficher_lalivraison);
    ls.set("afficher_facturation", afficher_facturation);
    ls.set("afficher_facture_fournisseur", afficher_facture_fournisseur);
    ls.set("afficher_devis", afficher_devis);
    ls.set("afficher_deliverect", afficher_deliverect);
    ls.set("afficher_cheques", afficher_cheques);
    ls.set(
      "afficher_privileges",
      afficher_privileges == undefined ? 0 : afficher_privileges
    );
    ls.set("current_account_caisse", cryptr.encrypt(id_account_caisse));
    ls.set("token", token);
    ls.set("password", cryptr.encrypt(params.password));
    ls.set("onglet", "1");
    ls.set("number_page_article", 1);
    ls.set("number_page_categorie", 1);
    ls.set("searchText", "");
    ls.set("caissename", "");
    ls.set("groupeclients", groupeclients);
    ls.set("reglesdereduction", reglesdereduction);
    ls.set("reglesdeprix", reglesdeprix);
    ls.set("channel_manager", channel_manager);
    ls.set("client_commun",client_commun)
    ls.set("isAdmin",isAdmin)
    ls.set("site_exist", site_exist);
    localStorage.setItem("diffuser_monCate" , 1)
    
    // Add permission fields to localStorage
    ls.set("view_own_documents", view_own_documents);     
    ls.set("devis_create", devis_create);
    ls.set("devis_update", devis_update);
    ls.set("devis_convert_to_proforma", devis_convert_to_proforma);
    ls.set("proforma_update", proforma_update);
    ls.set("proforma_generate_bon_sortie", proforma_generate_bon_sortie);
    ls.set("proforma_generate_bon_livraison", proforma_generate_bon_livraison);
    ls.set("proforma_convert_to_facture", proforma_convert_to_facture);
    ls.set("facture_view", facture_view);
    ls.set("account_name_scA", account_name_scA);
    ls.set("sc_uuid", sc_uuid);
    ls.set("show_store", show_store);
    ls.set("from_admin_temp_password", from_admin_temp_password);
    ls.set("temp_tableau_de_bord", temp_tableau_de_bord);
    ls.set("afficher_mon_compte", afficher_mon_compte);
    // 2FA: suggest enabling it after login (main account, not yet enabled).
    ls.set("otp_enabled", data.otp_enabled ? 1 : 0);
    // Session opened with a temporary password: no dashboard (also enforced in CheckSTATUS)
    // and no 2FA suggestion.
    ls.set("temporary_login", data.temporary_login ? 1 : 0);
    ls.set("otp_suggest", data.otp_available && !data.otp_enabled && !data.temporary_login ? 1 : 0);
    // AI assistant (SQL chat) visibility: fos_user.ai_activation of the account.
    ls.set("ai_activation", data.ai_activation ? 1 : 0);



    if (id_account_caisse == ACCOUNT_CAISSE_POLEPARA) {
      ls.set("polepara", 1);
    } else {
      ls.set("polepara", 0);
    }
    if (id_account_caisse == ACCOUNT_CAISSE_SAID) {
      ls.set("cheque", 1);
    } else {
      ls.set("cheque", 0);
    }
    return token;
  },
  // redirectTo: page to open right after (e.g. "/login"). Without it the current page is reloaded,
  // as before — but a back-office page reloaded without a session crashes into a white page, so
  // the pages of the back office pass "/login".
  signout(cb, redirectTo) {
    this.isAuthenticated = false;
    localStorage.clear();
    ls.set("passwordmodal", ADMIN_PASSWORD);
    ls.set("glovo", 1);
    if (redirectTo) window.location.replace(redirectTo);
    else window.location.reload(true);
    return this.isAuthenticated;
  },
};

export default Connexion;
